<template>
  <div sticky-container>
    <LoadingPage v-if="loadingData"></LoadingPage>
    <v-card
      v-if="!loadingData"
      v-sticky
      sticky-offset="{top: 106}"
      class="py-1"
    >
      <v-tabs v-model="current_tab" background-color="primary" dark show-arrows>
        <v-tab v-for="year in yearsWithArticles" :key="year">{{ year }}</v-tab>
      </v-tabs>
    </v-card>
    <ArticlesTab
      :year="currentYear"
      @gotopage="gotoArticleHandler"
    ></ArticlesTab>
  </div>
</template>

<script>
import APIService from '@/apiservices/APIService.js'
import ArticlesTab from '@/components/ArticlesTab.vue'
import LoadingPage from '@/components/LoadingPage.vue'
import Sticky from 'vue-sticky-directive'

export default {
  directives: { Sticky },
  components: {
    ArticlesTab,
    LoadingPage
  },

  data() {
    return {
      current_tab: null,
      yearsWithArticles: [],
      loadingData: false,
      articleIds: []
    }
  },
  watch: {
    current_tab: function(newVal) {
      this.$store.dispatch('setHomeblogYearTabIndex', newVal)
    }
  },
  computed: {
    currentYear() {
      if (this.yearsWithArticles && this.yearsWithArticles[this.current_tab]) {
        return this.yearsWithArticles[this.current_tab]
      } else {
        return NaN
      }
    }
  },
  created() {
    this.current_tab = this.$store.getters.getHomeblogYearTabIndex
    this.loadingData = true

    let loadingYears = true
    let loadingArticleIds = true

    APIService.getYearsWithArticles()
      .then(({ data }) => {
        this.yearsWithArticles = data.map(x => x.year).reverse()
        loadingYears = false
        if (!loadingArticleIds) {
          this.loadingData = false
        }
      })
      .catch(error => {
        console.log(
          'There was an error in getYearsWithArticles API call:',
          error
        )
      })

    APIService.getArticleIds({})
      .then(({ data }) => {
        this.articleIds = data.map(x => x.id)
        loadingArticleIds = false
        if (!loadingYears) {
          this.loadingData = false
        }
      })
      .catch(error => {
        console.log('There was an error in getArticleIds API call:', error)
      })
  },
  methods: {
    gotoArticleHandler(articleId) {
      let index = this.articleIds.indexOf(articleId)
      console.log(index)
      this.$emit('gotopage', index + 1)
    }
  }
}
</script>

<style></style>
